export default class GoogleMap {

    constructor () {
        this.map = null
        const maps = document.querySelectorAll('.google-map')

        maps.forEach(el => {
            this.map = this.initMap(el)
        })
    }


    initMap ($el) {
        // var
        var $markers = $el.querySelectorAll('.marker')


        // vars
        var args = {
            zoom: 16,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        }


        // create map	        	
        const map = new google.maps.Map($el, args)

        // add a markers reference
        map.markers = []


        // add markers
        $markers.forEach(($el) => {
            this.addMarker($el, map)
        })


        // center map
        this.centerMap(map)


        // return
        return map

    }

    addMarker ($marker, map) {

        // var
        var latlng = new google.maps.LatLng($marker.dataset.lat, $marker.dataset.lng)

        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
        })

        // add to array
        map.markers.push(marker)

        // if marker contains HTML, add it to an infoWindow
        if ($marker.innerHTML) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: $marker.innerHTML,
            })

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function () {

                infowindow.open(map, marker)

            })
        }

    }

    centerMap (map) {

        // vars
        var bounds = new google.maps.LatLngBounds()
        map.markers.forEach(marker => {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng())
            bounds.extend(latlng)
        })


        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter())
            map.setZoom(16)
        } else {
            // fit to bounds
            map.fitBounds(bounds)
        }

    }

}